import { IEnum_Solution_Item_Type, IEnum_Solution_Type } from 'src/graphql/generated/hooks'

const isSolutionType = (type: IEnum_Solution_Item_Type): boolean => {
  if (type === IEnum_Solution_Item_Type.Company) return false
  return true
}

export const convertSolutionItemTypeToSolutionType = (type: IEnum_Solution_Item_Type): IEnum_Solution_Type | null => {
  if (isSolutionType(type)) {
    return type as unknown as IEnum_Solution_Type
  }
  return null
}
